import CircularProgress from '@material-ui/core/CircularProgress';
import Hidden from '@material-ui/core/Hidden';
import React, { Component } from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";

import bgFooterImage from "assets/EnergyCompany/img/bg-footer.png";
import buttonTransparentBlueBorder from "assets/EnergyCompany/jss/button-transparent-blue-border.jsx";
import centerStyle from "./center";
import { sendMessage } from "services/contato";

const inputTextStyle = {
  border: "none",
  background: "#F6F6F6",
  borderRadius: "3px",
  height: "40px",
  padding: "0 10px",
};

const style = theme => ({
  button: {
    ...buttonTransparentBlueBorder,
    gridColumnStart: 2,
  },
  centeredSection: {
    ...centerStyle(theme),
    padding: "20px 0",
  },
  circularProgress: {
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
    position: "absolute",
    top: "50%",
  },
  disclaimer: {
    flex: 1,
    "& h4": {
      fontWeight: "bold",
    },
    "& p": {
      fontWeight: "400",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
      textAlign: "center",
    },
  },
  emailSentMessage: {
    gridColumnEnd: "span 2",
  },
  form: {
    flex: 1,
    display: "grid",
    gridGap: "15px",
    gridTemplateColumns: "1fr 1fr",
  },
  formCard: {
    backgroundColor: "white",
    borderRadius: "6px",
    display: "flex",
    padding: "50px",
    [theme.breakpoints.down("sm")]: {
      padding: "10px",
      display: "block",
    },
  },
  inputText: {
    ...inputTextStyle,
  },
  main: {
    alignItems: "center",
    backgroundImage: `url(${bgFooterImage})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    height: "440px",
  },
  sendButtonWrapper: {
    display: "flex",
    gridColumnStart: 2,
    justifyContent: "center",
    justifySelf: "flex-end",
    position: 'relative',
  },
  textarea: {
    ...inputTextStyle,
    gridColumn: "1 / span 2",
    height: "unset",
    padding: "10px",
  },
});

class Contato extends Component {
  state = {
    emailSentMessage: "",
    email: "",
    nome: "",
    msg: "",
    sending: false,
  };

  handleClick = () => {
    this.setState({ sending: true });
    const { email, nome, msg } = this.state;

    sendMessage({ email, nome, msg })
      .then(() => this.setState({
        emailSentMessage: "Mensagem enviada com sucesso, entraremos em contato em breve.",
        email: "",
        nome: "",
        msg: "",
        sending: false,
      }))
      .catch(() => this.setState({
        emailSentMessage: "Erro no envio da mensage, por favor tente novamente mais tarde.",
        sending: false,
      }));
  }

  render() {
    const { classes } = this.props;
    const { emailSentMessage, email, nome, msg, sending } = this.state;

    return (
      <main className={classes.main} id="contato">
        <section className={classes.centeredSection}>
          <div className={classes.formCard}>
            <div className={classes.disclaimer}>
              <h4>Entre em contato</h4>
              <Hidden smDown>
                <p>Ainda em dúvida? Envie uma mensagem e retornaremos o contato</p>
                <p>o mais rápido possível. Ou <a href="cadastro">cadastre-se</a> agora e tenha acesso livre</p>
                <p>durante <b>30 dias</b> para testar todas as nossas funcionalidades.</p>
                <p>Só comece a pagar se satisfeito.</p>
              </Hidden>
              <Hidden mdUp>
                <p>Envie uma mensagem para se cadastrar na Energy Company, retornaremos o contato o mais rápido possível. Tenha acesso livre durante <b>30 dias</b> para testar todas as nossas funcionalidades. Só comece a pagar se satisfeito.</p>
              </Hidden>
            </div>
            <div className={classes.form}>
              <input
                className={classes.inputText}
                onChange={e => this.setState({ nome: e.target.value })}
                placeholder="Nome"
                type="text"
                value={nome}
              />
              <input
                className={classes.inputText}
                onChange={e => this.setState({ email: e.target.value })}
                placeholder="E-mail"
                type="text"
                value={email}
              />
              <textarea
                className={classes.textarea}
                onChange={e => this.setState({ msg: e.target.value })}
                placeholder="Mensagem"
                rows="5"
                type="area"
                value={msg}
              />
              {emailSentMessage ?
                (
                  <p className={classes.emailSentMessage}>{emailSentMessage}</p>
                ) : (
                  <div className={classes.sendButtonWrapper}>
                    <button
                      className={classes.button}
                      disabled={sending}
                      onClick={this.handleClick}
                    >
                      Enviar
                    </button>
                    {sending && <CircularProgress className={classes.circularProgress} size={24} />}
                  </div>
                )
              }
            </div>
          </div>
        </section>
      </main>
    );
  };
};

Contato.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(style)(Contato);



// WEBPACK FOOTER //
// ./src/views/LandingPage/partials/5-contato.js